import { nanoid } from 'nanoid'

import { IComment } from '~/interfaces/Comment'
import { IDeploy } from '~/interfaces/netlify/Deploy'
import { messageGift } from '~/utils/messages'

export interface INotification {
  action?: Function
  cta?: string
  expiry?: number
  id: string
  intent: 'dot' | 'badge'
  message: string
  priority: number
  pulse: boolean
  type: 'comment' | 'deploy' | 'recording' | 'screenshot' | 'product'
}

export const notificationForRecording = (action: Function): INotification => {
  return {
    action,
    cta: 'Stop recording',
    id: nanoid(),
    intent: 'dot',
    message: 'Recording in progress...',
    priority: 910,
    pulse: true,
    type: 'recording',
  }
}

export const notificationForScreenshot = (secondsRemaining: number): INotification => {
  return {
    intent: 'dot',
    expiry: 1000,
    id: nanoid(),
    message: `Preparing to take a screenshot in ${secondsRemaining} ...`,
    priority: 900 + secondsRemaining,
    pulse: true,
    type: 'screenshot',
  }
}

export const notificationForComment = (comment: IComment, action: Function): INotification => {
  return {
    action,
    cta: 'View',
    id: nanoid(),
    intent: 'dot',
    message: comment.user.id ? `${comment.user.name} wrote a new comment.` : 'Someone left a new comment.',
    priority: 100,
    pulse: false,
    type: 'comment',
  }
}

export const notificationForDeploy = (deploy: IDeploy): INotification => {
  return {
    action: () => messageGift('REFRESH'),
    cta: 'Refresh',
    id: nanoid(),
    intent: 'dot',
    message: deploy.committer ? `${deploy.committer} deployed new changes.` : 'New changes have been deployed.',
    priority: 200,
    pulse: false,
    type: 'deploy',
  }
}

export const notificationForProductUpdate = (message: string, action: Function): INotification => {
  return {
    action,
    cta: 'View',
    id: nanoid(),
    intent: 'badge',
    message,
    priority: 10,
    pulse: false,
    type: 'product',
  }
}
